import React from "react";
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { axios_instance } from 'components/axios';
import CustomTable from "components/table";
import DashboardMenu from "templates/common/dashboard-menu";

const objectColumns = [
  {
    Header: "id",
    accesor: d => d,
    id: "id",
    show: false
  },
  {
    Header: "Id",
    accessor: d => d.id,
    id: 'name',
    sortable: false,
    filterable: false,
    style: {
      cursor: "pointer"
    },
    Cell: ({value}) => (value ? "Objeto " + value : "")
  },
  {
    Header: "Objeto",
    accessor: d => d.attributes["title"],
    id: 'title',
    sortable: false,
    filterable: false,
    style: {
      cursor: "pointer"
    }
  },
  {
    Header: "Tamaño",
    accessor: d => d.attributes["storage-item-type"],
    id: 'storage_item_type',
    style: {
      cursor: "pointer"
    },
    Filter: ({ filter, onChange }) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: "100%" }}
        value={filter ? filter.value : "all"}
      >
        <option value="all">Todos</option>
        <option value="medium">Mediano</option>
        <option value="large">Grande</option>
        <option value="extra_large">Grande</option>
        <option value="custom">Cotización</option>
      </select>
  },
  {
    Header: "Usuario",
    accessor: d => d.attributes["client-name"],
    id: 'user',
    sortable: false,
    filterable: true,
    style: {
      cursor: "pointer"
    }
  },
  {
    Header: "Activo?",
    accessor: d => d.attributes["active-status"],
    id: "active_status",
    style: {
      cursor: "pointer"
    },
    Cell: ({ value }) => (value === true ? "Sí" : "No"),
    filterMethod: (filter, row) => {
      if (filter.value === "all") {
        return true;
      }
      if (filter.value === "active") {
        return row[filter.id] === true;
      }
      return row[filter.id] === false;
    },
    Filter: ({ filter, onChange }) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: "100%" }}
        value={filter ? filter.value : "all"}
      >
        <option value="all">Todos</option>
        <option value="active">Activo</option>
        <option value="inactive">Inactivo</option>
      </select>
  }
];

export default class StorageItems extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: [],
      pages: null,
      loading: true,
      page: 1,
    };
  }

  fetchData = (state, instance) => {
    this.setState({ loading: true });
    let params = {
      page: state.page + 1,
      per_page: state.pageSize
    }

    if(state.sorted.length) {
      state.sorted.forEach(function(sort) {
        params[sort.id] = sort.desc ? "desc" : "asc"
      });
    }
    if (state.filtered.length) {
      state.filtered.forEach(function(filter) {
        params["by_" + filter.id] = filter.value;
      });
    }
    axios_instance.get("/v1/storage_items", {params})
    .then((res) => {
      if(res.data.data) {
        this.setState({
          data: res.data.data,
          loading: false,
          pages: res.data.meta.pagination["total-pages"],
        });
      }
    }).catch(() => {
    });
  }

  addWarehouse = () => {
    this.props.history.push('/storage-items/new')
  }

  render() {
    const { data, pages, loading } = this.state;
    return(
      <div className="dashboard-container">
        <DashboardMenu />
        <div className="dashboard-content">
          <div className="dashboard-content-header">
            <div className="dashboard-content-header-item">
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <h3 className="dashboard-content-header-title">Almacenar</h3>
                <div>
                  <button type="button" className="btn btn-primary" onClick={this.addWarehouse}>
                    + Agregar Objetos
                  </button>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div className="dashboard-content-body">
            <CustomTable {...this.props}
              columns={objectColumns}
              data={data}
              pages={pages}
              loading={loading}
              manual
              onFetchData={AwesomeDebouncePromise(this.fetchData, 300)}
              filterable
              defaultPageSize={10}
              defaultSorted={[
                {
                  id: "id",
                  desc: false
                }
              ]}
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if(column.Header) {
                      this.props.history.push(`/storage-items/${rowInfo.original.id}`, [rowInfo.original])
                    } else {
                      handleOriginal();
                    }
                  }
                }
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}
